import { default as React, useState } from 'react';
import { createRoot } from 'react-dom/client';

import { ImageSelectorModalCopy } from '../components/customModals';

 
export default class CustomImageTool {
 
  static get toolbox() {
    return {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 15v4H5v-4h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 18.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM19 5v4H5V5h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 8.5c-.82 0-1.5-.67-1.5-1.5S6.18 5.5 7 5.5s1.5.68 1.5 1.5S7.83 8.5 7 8.5z"/></svg>`,
      title: 'Afbeelding',
    };
  }
 
  static get isReadOnlySupported() {
    return true;
  }
 
  constructor({ data, config, api, readOnly }) {
    this.api = api;
    this.readOnly = readOnly;
    this.isVisible = false
    this.data = {
      image: {url:data?.image?.url} || {},
    };
 
    this.CSS = {
      wrapper: 'image-selector-stuff',
    };
 
    this.nodes = {
      holder: null,
    };
  }
 
  render() {
    const rootNode = document.createElement('div');
    rootNode.setAttribute('class', this.CSS.wrapper);
    const root = createRoot(rootNode)
    this.nodes.holder = rootNode;
    rootNode.addEventListener('keydown', (e) => {
      e.stopPropagation();
    });
    const Wrapper = () => {
        const [imageData, setImageData] = React.useState(this.data);
        const [visibleState, setVisibleState] = useState(false)
        const handleDismiss = () => {
          setVisibleState(false)
        }
        const onDataChange = (newData) => {
          setImageData(newData);
          this.data = newData; // Keep Editor.js data updated
          setVisibleState(false); // Close modal after selecting image
        };

        const handleImageClick = () => {
          if (!this.readOnly) {
            setVisibleState(true);
          }
        };

        // Don't render anything in read-only mode when no image is selected
        if (this.readOnly && !imageData?.image?.url) {
          return null;
        }
    
        return (
          <>
            {imageData?.image?.url ? (
              <div onClick={handleImageClick} style={{ cursor: this.readOnly ? 'default' : 'pointer' }}>
                <img 
                  style={{
                    minHeight:"8rem",
                    
                    marginTop:"1rem", 
                    marginBottom:"1rem", 
                    borderRadius:"0.4rem",
                    width: "100%",
                    objectFit: "contain",
                    maxHeight: "24rem"
                  }} 
                  src={imageData.image.url} 
                  alt="Selected" 
                />
                {!this.readOnly && (
                  <div style={{
                    textAlign: "center",
                    marginTop: "-3rem",
                    marginBottom: "2rem",
                    color: "white",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    padding: "0.5rem",
                    borderRadius: "0.4rem"
                  }}>
                    Klik om afbeelding te wijzigen
                  </div>
                )}
              </div>
            ) : !this.readOnly && (
              <div 
                onClick={handleImageClick}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "0.4rem",
                  padding: "2rem",
                  textAlign: "center",
                  cursor: "pointer",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                  backgroundColor: "#f9f9f9"
                }}
              >
                <div style={{ fontSize: "1.2rem", color: "#666" }}>
                  📷 Klik om een afbeelding toe te voegen
                </div>
              </div>
            )}
            {visibleState && !this.readOnly && (
              <ImageSelectorModalCopy 
                dismiss={handleDismiss} 
                imageSelected={onDataChange} 
                visible={visibleState} 
              />
            )}
          </>
        );
      };
    
    root.render(
      (
     <Wrapper/>
      ),
      rootNode);
 
    return this.nodes.holder;
  }
 
  save() {
    return this.data;
  }
}